import { newEntity } from 'entities-next/common'

import { ScoutingCampaign, ScoutingCampaignStatus } from './scoutingCampaign.types'

export function newScoutingCampaign(): ScoutingCampaign {
  return {
    ...newEntity(),
    name: 'New Space',
    status: ScoutingCampaignStatus.draft,
    corporateId: 0,
    description: '',
    editable: false,
    includeCompaniesWithoutMaturityInformation: false,
    internalIncludeCompaniesWithoutMaturityInformation: false,
    negativeKeywords: '',
    positiveKeywords: '',
    radarScouting: false,
    packageCountable: true,
    isDeleted: false,
  }
}
